import { render, staticRenderFns } from "./Controllers.vue?vue&type=template&id=0836b104"
import script from "./Controllers.vue?vue&type=script&lang=ts"
export * from "./Controllers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports